import { atom } from "jotai";

export const missionWidgetOpenAtom = atom(false);
